<template>
  <v-row class="initiative-gallery ma-0 my-md-16" no-gutters >
    <v-col cols="12" class="info" v-if="$vuetify.breakpoint.mdAndUp">
      <v-row no-gutters>
        <v-col cols="4" class="text-body-1 pb-16" style="position: relative;">
          <ul v-if="content.galleries.length > 1">
            <li v-for="(gallery, i) in content.galleries" :key="i" class="py-2 ma-0 px-0">
              <v-btn
                v-if="gallery.name"
                text small tile
                :class="{'v-btn--active': galleryIndexForElement(currentElement) === i}"
                @click="!$refs.gallery.transitioning && $refs.gallery.goTo(indexOfGallery(gallery))"
              >
                {{i.toString().padStart(2, '0')}} - {{gallery.name}}
              </v-btn>
            </li>
          </ul>
          <div class="text-right navigation"><span class="vogue-underlined py-3 px-1"><v-btn tile icon class="black--text" @click="!$refs.gallery.transitioning && $refs.gallery.prev()"><v-icon large>mdi-arrow-bottom-left</v-icon></v-btn></span></div>
        </v-col>
        <v-col cols="4" md="4" class="text-body-1 pb-md-16 px-0 text-center" style="position: relative;">
          <v-row no-gutters align="center" justify="center">
            <v-col style="font-size: 2rem;" cols="auto" class="font-weight-bold shrink">{{(galleryIndex + 1).toString().padStart(2, '0')}}</v-col>
            <v-col cols="auto" class="shrink">&nbsp;/&nbsp;{{allImages.length.toString().padStart(2, '0')}}</v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="4" class="text-body-1 pb-md-16 px-0" style="position: relative;">
          <MarkdownBlock v-if="currentElement.description" :text="currentElement.description" />
          <div class="text-left navigation"><span class="vogue-underlined py-3 px-1"><v-btn tile icon class="black--text" @click="!$refs.gallery.transitioning && $refs.gallery.next()"><v-icon large>mdi-arrow-top-right</v-icon></v-btn></span></div>
        </v-col>
      </v-row>
    </v-col>
    <horizontal-gallery ref="gallery" class="scroll-gallery mt-md-16 mx-0" :slides="allImages" loop :initial-index="0" :slice-length="3" :slice-offset="1" :align="$vuetify.breakpoint.mdAndUp ? 'end' : 'center'" @change="galleryIndex = $event" />
    <v-row align="center" justify="center" class="flex-nowrap text-center ma-0 mt-4" v-if="!$vuetify.breakpoint.mdAndUp">
      <v-col cols="auto" class="shrink vogue-underlined"><v-btn tile icon class="black--text" @click="!$refs.gallery.transitioning && $refs.gallery.prev()"><v-icon large>mdi-arrow-bottom-left</v-icon></v-btn></v-col>
      <v-col cols="auto" class="grow">
        <!-- <span>{{(galleryIndex + 1).toString().padStart(2, '0')}}</span> / <span>{{allImages.length.toString().padStart(2, '0')}}</span> -->
        <v-row no-gutters align="center" justify="center">
          <v-col style="font-size: 2rem;" cols="auto" class="font-weight-bold shrink">{{(galleryIndex + 1).toString().padStart(2, '0')}}</v-col>
          <v-col cols="auto" class="shrink">&nbsp;/&nbsp;{{allImages.length.toString().padStart(2, '0')}}</v-col>
        </v-row>
      </v-col>
      <v-col cols="auto" class="shrink vogue-underlined"><v-btn tile icon class="black--text" @click="!$refs.gallery.transitioning && $refs.gallery.next()"><v-icon large>mdi-arrow-bottom-right</v-icon></v-btn></v-col>
    </v-row>
  </v-row>
</template>

<script>
import MarkdownBlock from '@monogrid/vue-lib/lib/components/MarkdownBlock'
import HorizontalGallery from '@/atoms/HorizontalGallery.vue'

export default {
  name: 'InitiativeGallery',
  components: {
    HorizontalGallery,
    MarkdownBlock
  },
  data () {
    return {
      galleryIndex: 0
    }
  },
  props: {
    content: {
      type: Object,
      required: true
    },
    momentum: {
      type: Number,
      required: false,
      default () {
        return 0
      }
    },
    index: {
      type: Number,
      required: false,
      default () {
        return 0
      }
    }
  },
  methods: {
    galleryIndexForElement (element) {
      for (let i = 0; i < this.content.galleries.length; i++) {
        if (this.content.galleries[i].items.indexOf(element) !== -1) { return i }
      }
      return -1
    },
    indexOfGallery (gallery) {
      return this.allElements.indexOf(gallery.items[0])
    }
  },
  computed: {
    currentElement () {
      return this.allElements[this.galleryIndex]
    },
    allElements () {
      return this.content.galleries.flatMap((v) => v.items)
    },
    allImages () {
      return this.allElements.map(v => v.image)
    }
  }
}
</script>

<style lang="scss" scoped>
.initiative-gallery {
  position: relative;
  height: 90vh;
  @include breakpoint('sm-and-down') {
    height: auto;
  }
}

.scroll-gallery,
.info {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  @include breakpoint('sm-and-down') {
    position: relative;
  }
}

.scroll-gallery {
  @include breakpoint('sm-and-down') {
    width: 200vw;
    left: calc(-50vw - 16px);
    max-width: 200vw;
    min-width: 200vw;
  }
}

.info {
  z-index: $z-content-prominent;

  li {
    list-style: none;
  }
}

::v-deep {
  .gallery-image {
    .v-image {
      transform-origin: 50% 50%;
      transition: transform 0.8s $ease-in-out-quad;
      @include breakpoint('md-and-up') {
        transform-origin: 50% 100%;
      }
    }
  }

  .gallery-index-2,
  .gallery-index-0 {
    .v-image {
      @include breakpoint('md-and-up') {
        transform: scale3d(0.6, 0.6, 1);
      }
    }
  }
}

.navigation {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
